import './CreatorUpload.css';
import * as encryptUtils from './encryptDecryptUtils';
import * as loggingUtils from './utils/loggingUtils';
import * as mintUtils from './mintUtils';
import FileUpload from './FileUpload';
import CreatorUploadTitleForm  from './CreatorUploadTitleForm';
import CreatorUploadCreatorNameForm  from './CreatorUploadCreatorNameForm';
import CreatorUploadDescriptionForm from './CreatorUploadDescriptionForm';
import CreatorUploadMonetizationLiquidForm  from './CreatorUploadMonetizationLiquidForm';
import LiquidityQuestionForm from './LiquidityQuestionForm';
import HyperaceConnectWalletModal from './HyperaceConnectWalletModal';
import FileUploadImage from './FileUploadImage';
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import {
  bondingCurveOrchestratorContractAddress,
  mainnetBondingCurveOrchestratorContractAddress
} from "./config";

let web3;
let usedContractAddress;
if(process.env.REACT_APP_IS_MAINNET !== "testnet") {
  web3 = createAlchemyWeb3(process.env.REACT_APP_ETHEREUM_WEBSOCKET_URL);
  usedContractAddress = mainnetBondingCurveOrchestratorContractAddress;
} else {
  web3 = createAlchemyWeb3(process.env.REACT_APP_GOERLI_WEBSOCKET_URL);
  usedContractAddress = bondingCurveOrchestratorContractAddress;
}
const bondingCurveNFTV2JSON = require('./artifacts/contracts/BondingCurveNFTV2.sol/BondingCurveNFTV2.json');
const bondingCurveOrchestratorJSON = require('./artifacts/contracts/BondingCurveOrchestrator.sol/BondingCurveOrchestrator.json');

const axios = require('axios');

function LiquidUploadV2(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [publishInit, setPublishInit] = useState(false);
  const [usdPriceETH, setUsdPriceETH] = useState("Invalid coinbase exchange rate request");
  const [hasShownOpenMint, setHasShownOpenMint] = useState(false);
  const [streamerProfile, setStreamerProfile] = useState({});

  let params = {};

  useEffect(() => {
    const getUSDETH = async () => {
      let USDPriceETH = "Invalid coinbase exchange rate request"
      let data = await axios.get("https://api.coinbase.com/v2/exchange-rates", { params: { currency: "ETH" } });
      if(data != null) {
        USDPriceETH = data["data"]["data"]["rates"]["USD"]
      }
      return USDPriceETH;
    }
    getUSDETH().then(price => setUsdPriceETH(price));
  }, []);

  useEffect(() => {
    const getStreamerProfile = async () => {
      if(props.account == null) {
        return {};
      } else {
        return await encryptUtils.getStreamerProfileInfo(props.account.address.toLowerCase());
      }
    }
    getStreamerProfile().then(profile =>  setStreamerProfile(profile));
  }, []);

  async function mintNFT() {
    let tokenContractAddress = null;
    if(streamerProfile.createdItems != null) {
      let createdItems = streamerProfile.createdItems;
      for(let i = 0; i < createdItems.length; i++) {
        if(createdItems[i].protocol === "liquidv2") {
          tokenContractAddress = createdItems[i].tokenContractAddress;
          break;
        }
      }
    }

    console.log(params);
    console.log("A");
    if(publishInit) {
      return;
    }
    let liquidityPeriodLength = 0;
    if(params["date"] == null) {
      params["date"] = new Date();
    }
    if(params["time"] == null) {
      params["time"] = new Date();
    }
    let date = params["date"];
    let time = params["time"];
    if(params["isLiquidForever"] === false) {
      let mergedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 
                        time.getHours(), time.getMinutes(), time.getSeconds());
      liquidityPeriodLength = mergedDate - new Date();
      if(liquidityPeriodLength < 0) {
        // Liquidity period set to end in past
        return;
      }
    }
    console.log("B");
    console.log(params.name == null);
    console.log(params.name === "");
    console.log(params.file == null);
    console.log(params.file.length === 0);
    console.log(props.account == null);
    console.log(params.image == null);
    console.log(params.curve == null);
    console.log(params.curve === "");
    console.log(params.isLiquidityInstant == null);
    console.log(params.buyFee == null);
    console.log(params.sellFee == null);
    console.log(isNaN(params.buyFee));
    console.log(isNaN(params.sellFee));

    if(params.isLiquidityInstant == null) {
      params["isLiquidityInstant"] = true;
    }
    if(params.isNonLiquid === true) {
      params["buyFee"] = 0;
      params["sellFee"] = 0;
    }
    if(
      params.name == null || params.name === "" || params.file == null || params.file.length === 0 ||
      props.account == null || params.image == null || params.image.length === 0 ||
      params.curve == null || params.curve === "" || params.isLiquidForever == null ||
      params.buyFee == null || params.sellFee == null || isNaN(params.buyFee) || isNaN(params.sellFee) ||
      parseFloat(params.sellFee) > 100 || params.description == null || params.creatorName == null
    ) {
      // One of many fields is missing or invalid
      return;
    }
    console.log("C");
    if(params.curve === "Quadratic") {
      if(
        params.quadraticTermPolynomial == null || isNaN(params.quadraticTermPolynomial) ||
        parseFloat(params.quadraticTermPolynomial) > 100 || parseFloat(params.quadraticTermPolynomial) < 0 ||
        params.linearTermPolynomial == null || isNaN(params.linearTermPolynomial) ||
        parseFloat(params.linearTermPolynomial) > 100 || parseFloat(params.linearTermPolynomial) < 0 ||
        params.interceptPolynomial == null || isNaN(params.interceptPolynomial) ||
        parseFloat(params.interceptPolynomial) > 100 || parseFloat(params.interceptPolynomial) < 0
      ) {
        // Terms are either nonexistent, not numbers, negative, or too high (likely will result in overflows bc entered in Wei)
        return;
      }
    } else if(params.curve === "Linear") {
      if(
        params.linearTermPolynomial == null || isNaN(params.linearTermPolynomial) ||
        parseFloat(params.linearTermPolynomial) > 100 || parseFloat(params.linearTermPolynomial) < 0 ||
        params.interceptPolynomial == null || isNaN(params.interceptPolynomial) ||
        parseFloat(params.interceptPolynomial) > 100 || parseFloat(params.interceptPolynomial) < 0
      ) {
        // Terms are either nonexistent, not numbers, or too high (likely will result in overflows bc entered in Wei)
        return;
      }
    } else if(params.curve === "Horizontal") {
      if(
        params.interceptPolynomial == null || isNaN(params.interceptPolynomial) ||
        parseFloat(params.interceptPolynomial) > 100 || parseFloat(params.interceptPolynomial) < 0
      ) {
        // Terms are either nonexistent, not numbers, negative, or too high (likely will result in overflows bc entered in Wei)
        return;
      }
    } else if(params.curve === "Sigmoid") {
      if(
        params.sigmoidGrowth == null || isNaN(params.sigmoidGrowth) ||
        parseFloat(params.sigmoidGrowth) > 1000 || parseFloat(params.sigmoidGrowth) < 0 ||
        params.sigmoidPriceRange == null || isNaN(params.sigmoidPriceRange) ||
        parseFloat(params.sigmoidPriceRange) > 1000 || parseFloat(params.sigmoidPriceRange) < 0 ||
        params.sigmoidInflectionPoint == null || isNaN(params.sigmoidInflectionPoint) ||
        parseFloat(params.sigmoidInflectionPoint) > 1000 || parseFloat(params.sigmoidInflectionPoint) < 0 ||
        params.sigmoidCurveAdjustment == null || isNaN(params.sigmoidCurveAdjustment) ||
        parseFloat(params.sigmoidCurveAdjustment) > 100 || parseFloat(params.sigmoidCurveAdjustment) < 0
      ) {
        // Terms are either nonexistent, not numbers, negative, or too high (likely will result in overflows bc entered in Wei)
        return;
      }
    } else {
      // Somehow curve type is invalid
      return;
    }
    console.log("D");
    setPublishInit(true);
    loggingUtils.logEvent(
      props.account != null ? props.account.address : encryptUtils.getWalletUnconnectedUserId(),
      'creator_upload',
      'creator_upload_bonding_curve_item',
      'info',
      "https://the402.xyz",
      {},
    );
    const title = params.name;
    const file = params.file[0];
    params["creatorAddress"] = props.account.address;

    // upload cover photo to pinata
    let coverPhotoURL = await encryptUtils.writeFilePinata(title, params.image);
    let animationURL = await encryptUtils.writeFilePinata(title, params.file);
    params["animation_url"] = animationURL.replace('gateway.pinata', 'the402.mypinata');
    params["imagePinata"] = coverPhotoURL.replace('gateway.pinata', 'the402.mypinata');
    params["image"] = coverPhotoURL.replace('gateway.pinata', 'the402.mypinata');

    let authUUID = encryptUtils.getAuthUUID();

    //upload file to s3 not encrypted and update the params for the file
    const fileType = file.type;
    let mediaType;
    if(fileType.match("image")) {
      mediaType = 2;
    } else if(fileType.match("audio")){
      mediaType = 1;
    } else if (fileType.match("video")){
      mediaType = 0;
    }

    params["mediaType"] = mediaType;

    // upload the metadata
    let ppvHash = await encryptUtils.writeMetadataPinataBondingCurve(params);
    console.log(ppvHash);

    const bondingCurveOrchestratorContract = new web3.eth.Contract(bondingCurveOrchestratorJSON.abi, usedContractAddress);
    bondingCurveOrchestratorContract.events.UpcomingBondingCurveMintPublished().on("data", async function(event) {
      let data = event.returnValues;
      console.log(data);
      console.log(authUUID);
      if(data["authUUID"] !== authUUID || hasShownOpenMint) {
        return;
      }
      let nextCollectibleID = parseInt(data["tokenId"]);
      setHasShownOpenMint(true);
      await mintUtils.openMint(props.account.address, nextCollectibleID, "liquidv2");
      navigate("/media/" + authUUID + "?protocol=liquidv2&autorefresh=true");
    });

    let parameters = [];
    if(params["curve"] === "Sigmoid") {
      parameters = [
        parseInt(params["sigmoidPriceRange"]),
        parseInt(params["sigmoidInflectionPoint"]),
        parseInt(params["sigmoidGrowth"]),
        parseInt(params["sigmoidCurveAdjustment"]),
      ];
    } else if(params["curve"] === "Quadratic") {
      parameters = [
        web3.utils.toWei(params["quadraticTermPolynomial"].toString()),
        web3.utils.toWei(params["linearTermPolynomial"].toString()),
        web3.utils.toWei(params["interceptPolynomial"].toString()),
      ];
    } else if(params["curve"] === "Linear") {
      parameters = [
        web3.utils.toWei(params["linearTermPolynomial"].toString()),
        web3.utils.toWei(params["interceptPolynomial"].toString()),
      ];
    } else {
      parameters = [web3.utils.toWei(params["interceptPolynomial"].toString())];
    }

    if(tokenContractAddress == null) {
      tokenContractAddress = await mintUtils.deployBondingCurveNFTV2Contract(
        props.account.address
      );
      console.log("Deploying new contract");
    } else {
      console.log("Skipping contract deploy");
      console.log("Using existing contract: " + tokenContractAddress);
    }
    console.log(ppvHash);
    console.log(props.account.address);
    console.log(mediaType);
    console.log(authUUID);
    console.log(parseInt(params.buyFee)*10);
    console.log(parseInt(params.sellFee)*10);
    console.log(params["isLiquidityInstant"]);
    console.log(params["isNonLiquid"]);
    console.log(params["curve"] === "Sigmoid");
    console.log(Math.floor(liquidityPeriodLength / 1000));
    console.log(parameters);
    await mintUtils.publishUpcomingBondingCurveMintWithInfoV2(
      ppvHash,
      props.account.address,
      mediaType,
      authUUID,
      parseInt(params.buyFee)*10,
      parseInt(params.sellFee)*10,
      params["isLiquidityInstant"],
      params["isNonLiquid"],
      params["curve"] === "Sigmoid",
      Math.floor(liquidityPeriodLength / 1000),
      parameters,
      tokenContractAddress
    );
  }

  function setFile(file) {
    params["file"] = file;
  }

  function setCoverPhoto(coverPhoto) {
    params["image"] = coverPhoto;
  }

  function setCreatorName(creatorName) {
    params["creatorName"] = creatorName;
  }

  function setTitle(title) {
    params["name"] = title;
  }

  function setDescription(description) {
    params["description"] = description;
  }

  function setCurve(curve) {
    params["curve"] = curve;
  }

  async function setMintPrice(price) {
    params["mintPrice"] = price;
    let data = await axios.get("https://api.coinbase.com/v2/exchange-rates", { params: { currency: "ETH" } });
    if(data != null) {
      let USDPrice = data["data"]["data"]["rates"]["USD"]
      params["USD"] = (price * USDPrice).toFixed(2);
    }
  }

  function setSellFee(sellFee) {
    params["sellFee"] = sellFee;
  }

  function setBuyFee(buyFee) {
    params["buyFee"] = buyFee;
  }

  function setIsLiquidForever(isLiquidForever) {
    params["isLiquidForever"] = isLiquidForever;
  }

  function setIsLiquidityInstant(isLiquidityInstant) {
    params["isLiquidityInstant"] = isLiquidityInstant;
  }

  function setIsNonLiquid(isNonLiquid) {
    params["isNonLiquid"] = isNonLiquid;
  }

  function setDate(date) {
    params["date"] = date;
  }

  function setTime(time) {
    params["time"] = time;
  }

  function setInterceptPolynomial(interceptPolynomial) {
    params["interceptPolynomial"] = interceptPolynomial;
  }

  function setLinearTermPolynomial(linearTermPolynomial) {
    params["linearTermPolynomial"] = linearTermPolynomial;
  }

  function setQuadraticTermPolynomial(quadraticTermPolynomial) {
    params["quadraticTermPolynomial"] = quadraticTermPolynomial;
  }

  function setSigmoidGrowth(sigmoidGrowth) {
    params["sigmoidGrowth"] = sigmoidGrowth;
  }

  function setSigmoidPriceRange(sigmoidPriceRange) {
    params["sigmoidPriceRange"] = sigmoidPriceRange;
  }

  function setSigmoidInflectionPoint(sigmoidInflectionPoint) {
    params["sigmoidInflectionPoint"] = sigmoidInflectionPoint;
  }

  function setSigmoidCurveAdjustment(sigmoidCurveAdjustment) {
    params["sigmoidCurveAdjustment"] = sigmoidCurveAdjustment;
  }

  function checkString(str) {
    return (str.match(/^[0-9]+$/) != null);
  }

  function checkStringWithDecimal(str) {
    return !isNaN(str) && parseFloat(str) >= 0;
  }

  function checkStringWithHalfIncrements(str) {
    return !isNaN(str) && parseFloat(str) % 0.5 === 0 && parseFloat(str) >= 0;
  }

  return (
    <div>
      {
        props.account != null
          ?
        <div className = "max-w-lg mx-auto pt-24">
          <div>
            <div>
              <FileUpload setMedia={setFile} isHyperace={false} />
              <div className="mt-8">
                <FileUploadImage setMedia={setCoverPhoto}/>
              </div>
            </div>
            <CreatorUploadTitleForm setTitle={setTitle} params={params}/>
            <CreatorUploadCreatorNameForm setCreatorName={setCreatorName} params={params}/>
            <CreatorUploadDescriptionForm
              setDescription={setDescription}
              params={params}
            />
            <LiquidityQuestionForm
              checkStringWithHalfIncrements={checkStringWithHalfIncrements}
              setBuyFee={setBuyFee}
              setIsLiquidForever={setIsLiquidForever}
              setIsNonLiquid={setIsNonLiquid}
              setIsLiquidityInstant={setIsLiquidityInstant}
              setSellFee={setSellFee}
              setDate={setDate}
              setTime={setTime}
            />
            <div className="creator-upload-titleFormContainer">
              <CreatorUploadMonetizationLiquidForm
                checkString={checkString}
                checkStringWithDecimal={checkStringWithDecimal}
                checkStringWithHalfIncrements={checkStringWithHalfIncrements}
                setMintPrice={setMintPrice}
                setRoyalty={() => {}}
                shouldSetRoyalty={false}
                setCurve={setCurve}
                setInterceptPolynomial={setInterceptPolynomial}
                setLinearTermPolynomial={setLinearTermPolynomial}
                setQuadraticTermPolynomial={setQuadraticTermPolynomial}
                setSigmoidGrowth={setSigmoidGrowth}
                setSigmoidPriceRange={setSigmoidPriceRange}
                setSigmoidInflectionPoint={setSigmoidInflectionPoint}
                setSigmoidCurveAdjustment={setSigmoidCurveAdjustment}
                usdPriceETH={usdPriceETH}
                params={params}
              />
            </div>
          </div>
          <div className="h-24">
            {
              publishInit
                ?
              <div className="mx-auto text-center justify-center items-center">
                <div className="mx-auto mt-8 bg-black dark:bg-white h-16 w-64 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer" onClick={mintNFT}>
                  <svg role="status" class="w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                  </svg>
                  Please Wait
                </div>
                <div className="mt-2 text-black dark:text-white">
                  You will have to sign 3 transactions
                </div>
              </div>
                :
              <div className="mx-auto mt-8 bg-black dark:bg-white h-16 w-64 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer" onClick={mintNFT}>
                Confirm and upload
              </div>
            }
          </div>
        </div>
          :
        <div className="w-full">
          <HyperaceConnectWalletModal/>
        </div>
      }
    </div>
  );
}

export default LiquidUploadV2;